import React from "react";
import AboutHero from "@/components/about/AboutHero";
import OurValues from "@/components/about/OurValues";
import OurAchievements from "@/components/about/OurAchievements";
import NavigatingExperience from "@/components/about/NavigatingExperience";
import MeetTheTeam from "@/components/about/MeetTheTeam";
import { Testimonials } from "@/components/home/Testimonials";
import CTASection from "@/components/home/CTASection";

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <AboutHero />

      {/* Our Values Section */}
      <OurValues />

      {/* Our Achievements Section */}
      <OurAchievements />

      {/* Navigating Experience Section */}
      <NavigatingExperience />

      {/* Meet the Team Section */}
      <MeetTheTeam />

      {/* What Our Clients Say Section */}
      <Testimonials />

      {/* CTA Section */}
      <CTASection />

    
    </div>
  );
};

export default About;
